import { render } from "./Township.vue?vue&type=template&id=955ea51c"
import script from "./Township.vue?vue&type=script&lang=js"
export * from "./Township.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Township.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "955ea51c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('955ea51c', __exports__)) {
    api.reload('955ea51c', __exports__)
  }
  
  module.hot.accept("./Township.vue?vue&type=template&id=955ea51c", () => {
    api.rerender('955ea51c', render)
  })

}


export default __exports__